module.exports = ".mycheckbox {\n  margin-right: 30px;\n}\n"